import api from "@/services/api";
import store from "@/store"
import AccountService from '@/services/account.service'
import userService from "@/services/user.service"
import personService from "@/services/person.service"
import unavailabilityService from '@/services/unavailability.service'

export const account = {
  namespaced: true,
  state: {
    uuid: null,
    name: null,
    sid: null,
    reasons: [],
    places: [],
    persons: [],
    setting: [],
    unavailabilityReasons: [],
    permissions: [],
    lastPersonAdded: null,
    lastPersonSelected: null,
  },
  actions: {
    async load(context) {
      let currentAccount = null

      if(localStorage.getItem('current_account')) {
        currentAccount = JSON.parse(localStorage.getItem('current_account'))

        if(currentAccount.sid !== localStorage.getItem('account_name')) {
          currentAccount = null
        }
      }

      if(currentAccount !== null) {
        context.commit('init')
      } else {
        await AccountService.get().then(async (response) => {
          context.commit('load', response)

          await Promise.all([
            AccountService.getReasons(),
            AccountService.getPlaces(),
            AccountService.getSetting(),
            unavailabilityService.getReasons(),
            userService.getPermission(store.state.account.uuid),
          ]).then((values) => {
            context.commit('loadReasons', values[0].reasons)
            context.commit('loadPlaces', values[1].places)
            context.commit('loadSetting', values[2].setting)
            context.commit('loadUnavailabilityReasons', values[3].unavailability_reasons)
            context.commit('loadPermissions', values[4].permissions)

            localStorage.setItem('current_account', JSON.stringify(context.state))
          })
        })
      }
    },
    async reset(context) {
      context.commit('load', {
        uuid: '',
        name: '',
        sid: '',
      })

      context.commit('loadReasons', [])
      context.commit('loadPlaces', [])
      context.commit('loadSetting', [])
      context.commit('loadUnavailabilityReasons', [])
      context.commit('loadPermissions', [])

      localStorage.setItem('current_account', JSON.stringify(context.state))
    },
    async loadPersons(context, persons) {
      context.commit('loadPersons', persons)
    },
    async updateSetting(context, data) {
      await api.patch('/account/' + store.state.account.uuid + '/setting/' + context.state.setting.id, data).then(response => {
        context.commit('updateSetting', response.data)

        return response.data;
      });
    },
    async addReason(context, data) {
      context.commit('addReason', data)
    },
    async updateReason(context, data) {
      context.commit('updateReason', data)
    },
    async removeReason(context, { id, newId }) {      
      await api.delete('/account/' + store.state.account.uuid + '/reason/' + id + '/to/' + newId).then((response) => {
        context.commit('removeReason', id)

        return response.data
      });
    },
    async addPlace(context, data) {
      context.commit('addPlace', data)
    },
    async updatePlace(context, data) {
      context.commit('updatePlace', data)
    },
    async removePlace(context, { id, newId }) {      
      await api.delete('/account/' + store.state.account.uuid + '/place/' + id + '/to/' + newId).then((response) => {
        context.commit('removePlace', id)

        return response.data
      });
    },
    async addPerson(context, data) {
      if(data.person_group_uuid) {
        await personService.create(data, data.person_group_uuid).then((response) => {
          context.commit('addPerson', response)
        })
      } else {
        await personService.createByAccount(data).then((response) => {
          context.commit('addPerson', response)
        })
      }
    },
    async addPersonSelected(context, data) {
      context.commit('addPersonSelected', data)
    },
    async updatePerson(context, data) {
      if(data.person_group_uuid != null) {
        await personService.modify(data, data.person_group_uuid).then(response => {
          context.commit('updatePerson', response)
  
          return response.data
        })
      } else {
        await personService.modifyByAccount(data).then(response => {
          context.commit('updatePerson', response)
  
          return response.data
        })
      }
    },
    async addUnavailabilityReason(context, data) {
      context.commit('addUnavailabilityReason', data)
    },
    async updateUnavailabilityReason(context, data) {
      context.commit('updateUnavailabilityReason', data)
    },
    async removeUnavailabilityReason(context, id) {      
      context.commit('removeUnavailabilityReason', id)
    },
  },
  mutations: {
    init(state) {
      /*this.replaceState(
        Object.assign(state, JSON.parse(localStorage.getItem('current_account')))
      );*/

      state = Object.assign(state, JSON.parse(localStorage.getItem('current_account')))
    },
    load(state, account) {
      state.uuid = account.uuid
      state.name = account.name
      state.sid = account.sid

      localStorage.setItem('current_account', JSON.stringify(state))
    },
    loadReasons(state, reasons) {
      state.reasons = reasons

      localStorage.setItem('current_account', JSON.stringify(state))
    },
    loadPlaces(state, places) {
      state.places = places

      localStorage.setItem('current_account', JSON.stringify(state))
    },
    loadPersons(state, persons) {
      state.persons = persons
    },
    loadSetting(state, setting) {
      state.setting = setting

      localStorage.setItem('current_account', JSON.stringify(state))
    },
    loadUnavailabilityReasons(state, reasons) {
      state.unavailabilityReasons = reasons

      localStorage.setItem('current_account', JSON.stringify(state))
    },
    loadPermissions(state, permissions) {
      if(permissions == 'owner') {
        state.permissions = permissions
      } else {
        state.permissions = permissions.split('')
      }

      localStorage.setItem('current_account', JSON.stringify(state))
    },
    updateSetting(state, data) {
      state.setting = data
      localStorage.setItem('current_account', JSON.stringify(state));
    },
    addPersonSelected(state, person) {
      state.lastPersonSelected = person
      localStorage.setItem('current_account', JSON.stringify(state));
    },
    addReason(state, reason) {
      api.post('/account/' + store.state.account.uuid + '/reason', reason).then(response => {
        const data = response.data

        state.reasons.push({
          'id': data.id,
          'name': data.name,
          'color': data.color,
          'duration': data.duration,
          'duration_min': data.duration_min,
          'duration_max': data.duration_max,
        });

        localStorage.setItem('current_account', JSON.stringify(state))

        return response.data
      });
    },
    updateReason(state, data) {
      api.patch('/account/' + store.state.account.uuid + '/reason/' + data.id, {
        name: data.name,
        color: data.color,
        duration: data.duration,
        duration_min: data.duration_min,
        duration_max: data.duration_max,
      }).then(response => {
        var foundIndex = state.reasons.findIndex(element => element.id == data.id)

        state.reasons[foundIndex].name = data.name
        state.reasons[foundIndex].color = data.color
        state.reasons[foundIndex].duration = data.duration
        state.reasons[foundIndex].duration_min = data.duration_min
        state.reasons[foundIndex].duration_max = data.duration_max

        localStorage.setItem('current_account', JSON.stringify(state));

        return response.data
      })
    },
    removeReason(state, reasonId) {
      state.reasons = state.reasons.filter((object) => {
        return object.id !== reasonId;
      });

      localStorage.setItem('current_account', JSON.stringify(state));
    },
    addPlace(state, place) {
      api.post('/account/' + store.state.account.uuid + '/place', place).then(response => {
        const data = response.data

        state.places.push({
          'id': data.id,
          'name': data.name,
          'color': data.color,
        });

        localStorage.setItem('current_account', JSON.stringify(state));

        return response.data
      });
    },
    updatePlace(state, data) {
      api.patch('/account/' + store.state.account.uuid + '/place/' + data.id, {
        name: data.name,
        color: data.color,
      }).then(response => {
        var foundIndex = state.places.findIndex(element => element.id == data.id);
        state.places[foundIndex].name = data.name
        state.places[foundIndex].color = data.color

        localStorage.setItem('current_account', JSON.stringify(state));

        return response.data
      })
    },
    removePlace(state, placeId) {
      state.places = state.places.filter((object) => {
        return object.id !== placeId;
      });

      localStorage.setItem('current_account', JSON.stringify(state));
    },
    addPerson(state, responsePerson) {
        //state.persons.push(responsePerson)
        state.persons[responsePerson.uuid] = responsePerson
        state.lastPersonAdded = responsePerson

        localStorage.setItem('current_account', JSON.stringify(state));
    },
    updatePerson(state, responsePerson) {
      //let foundIndex = state.persons.findIndex(element => element.id == responsePerson.id);
      //state.persons[foundIndex] = responsePerson
      state.persons[responsePerson.uuid] = responsePerson
      
      localStorage.setItem('current_account', JSON.stringify(state));
    },
    addUnavailabilityReason(state, reason) {
      api.post('/account/' + store.state.account.uuid + '/unavailability-reason', reason).then(response => {
        const data = response.data

        state.unavailabilityReasons.push({
          'id': data.id,
          'name': data.name,
        });

        localStorage.setItem('current_account', JSON.stringify(state));

        return response.data
      });
    },
    updateUnavailabilityReason(state, data) {
      api.patch('/account/' + store.state.account.uuid + '/unavailability-reason/' + data.id, {
        name: data.name,
      }).then(response => {
        var foundIndex = state.unavailabilityReasons.findIndex(element => element.id == data.id);
        state.unavailabilityReasons[foundIndex].name = data.name

        localStorage.setItem('current_account', JSON.stringify(state));

        return response.data
      })
    },
    removeUnavailabilityReason(state, reasonId) {
      api.delete('/account/' + store.state.account.uuid + '/unavailability-reason/' + reasonId)
      .then(response => {
        state.unavailabilityReasons = state.unavailabilityReasons.filter((object) => {
          return object.id !== reasonId;
        });

        localStorage.setItem('current_account', JSON.stringify(state))

        return response.data
      })
    },
  }
};
